module.exports = __webpack_public_path__ + "img/skydown-white.edc47e04.png";